import { Alert, AlertDescription, AlertTitle } from "@/components/shadcn/alert";
import { Skeleton } from "@/components/shadcn/skeleton";
import Icon from "@/components/icon";

// Error — distinct from "no results": the lookup failed, offer a retry (F2).
export function DropdownError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="p-3">
      <Alert variant="destructive">
        <Icon name="triangle-alert" className="h-4 w-4" />
        <AlertTitle>Nie udało się wczytać podpowiedzi</AlertTitle>
        <AlertDescription className="mt-1 flex flex-col gap-2">
          <span>Sprawdź połączenie albo spróbuj ponownie.</span>
          <button
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={onRetry}
            className="inline-flex w-fit items-center gap-1.5 rounded-md border border-destructive/40 px-2.5 py-1 text-xs font-medium text-destructive transition-colors hover:bg-destructive/10"
          >
            <Icon name="refresh-cw" className="h-3.5 w-3.5" />
            Spróbuj ponownie
          </button>
        </AlertDescription>
      </Alert>
    </div>
  );
}

// Loading the first set of suggestions: skeletons, not an empty flash (F).
export function DropdownLoading() {
  return (
    <div className="flex w-full flex-col gap-1 p-3" aria-hidden>
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex w-full items-center gap-4 px-1 py-2.5">
          <Skeleton className="h-4 min-w-0 flex-1" />
          <Skeleton className="h-5 w-16 shrink-0 rounded-full" />
        </div>
      ))}
    </div>
  );
}
